import { render, staticRenderFns } from "./RiskScenarioValidation.vue?vue&type=template&id=46d7e179&scoped=true&"
import script from "./RiskScenarioValidation.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7e179",
  null
  
)

export default component.exports